<template>
  <div>
    <!--查询条件-->
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="formData" label-width="95px"  size="mini">
        <div class="formItemBox">
        <el-form-item label="入库单号:">
          <el-input class="ipt" v-model="formData.instockNo" placeholder="请输入入库单号" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="车号:">
          <el-input class="ipt" v-model="formData.instockPlateNumber" placeholder="请输入车号" size="mini" ></el-input>
        </el-form-item>
        <el-form-item label="一级货主:">
          <el-select size="mini" filterable clearable placeholder="请选择一级货主" v-model="formData.primaryCustomerTaxId">
            <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级货主:">
          <el-select size="mini" clearable filterable placeholder="请选择二级货主" v-model="formData.secondaryCustomerTaxId">
            <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="货物类型:">
          <el-select v-model="formData.productType" clearable @change="productTypeChange" placeholder="请选择" filterable size="mini">
            <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName" :value="item.productType">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产地:">
          <el-select v-model="formData.steelMillName" @change='steelMillNameChange' clearable placeholder="请选择" filterable size="mini">
            <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规格:">
          <el-select v-model="formData.specification" clearable @change='specificationChange' placeholder="请选择" filterable size="mini">
            <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="材质:">
          <el-select v-model="formData.model" @change="modelChange" clearable placeholder="请选择" filterable size="mini">
            <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入库日期:">
          <div style="display: flex;">
          <el-date-picker v-model="formData.instockDateStart" size="mini" type="datetime" placeholder="选择入库日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          -
          <el-date-picker v-model="formData.instockDateEnd" size="mini" placeholder="选择入库日期" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </div>
        </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" size="mini" @click="chaxun" btnCode="00ZP007B00P" v-if="btnFlg[24]">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi" btnCode="00ZP007B00Q" v-if="btnFlg[25]">重置</el-button>
          <el-button type="primary" size="mini" @click="daochu" btnCode="00ZP007B00R" v-if="btnFlg[26]">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--  表格  v-loading='tabLoading'-->

    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="tableRef" border bordersize="mini" height="100%" style="width: 100%; margin-top: 10px" center :header-cell-style="{ background: '#F5F5F5', color: 'black' }" :header-row-style="{ height: '45px' }" :row-style="{ height: '35px' }" highlight-current-row>
        <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="instockDate" label="入库日期" align="center" width="180"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="instockNo" label="入库单号" align="center" width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="车号" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center" width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="secondaryCustomerName" label="二级货主" align="center" width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center" width="70"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" align="center" width="120">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）" align="center" width="120">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weighingWeight" label="过磅净重（吨）" align="center" width="120">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weighingDate" label="过磅净重时间" align="center" width="180"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="factoryWeight" label="出厂过磅净重（吨）" align="center" width="120">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" align="center" width="180"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号" align="center" width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createUser" label="删除人" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createTime" label="删除时间" align="center" width="180"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-sizes="[10, 20, 30, 40,50]" :page-size="pageInfo.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  getRelationCustomer, // 字典客户
  getVirtualBalingList, // 货物类型、产地、规格、材质、长度、件数级联查询
  JfgetDeleteInStockExpList
} from '@/api/wms-stock.js'
import { exportExcel } from '@/utils/fileDown.js'
import { getBtn } from '@/utils/getButton'
import { emptyFn, formatterRowEmpty } from '@/utils/util'
import DonMessage from '@/utils/message'

export default {
  data () {
    return {
      emptyFn: emptyFn,
      formatterRowEmpty: formatterRowEmpty,
      // 按钮
      btnFlg: [],
      btnIdArr: [
        '00ZP007B001',
        '00ZP007B002',
        '00ZP007B003',
        '00ZP007B004',
        '00ZP007B005',
        '00ZP007B006',
        '00ZP007B007',
        '00ZP007B008',
        '00ZP007B009',
        '00ZP007B00A',
        '00ZP007B00B',
        '00ZP007B00C',
        '00ZP007B00D',
        '00ZP007B00E',
        '00ZP007B00F',
        '00ZP007B00G',
        '00ZP007B00H',
        '00ZP007B00I',
        '00ZP007B00J',
        '00ZP007B00K',
        '00ZP007B00L',
        '00ZP007B00M',
        '00ZP007B00N',
        '00ZP007B00O',
        '00ZP007B00P',
        '00ZP007B00Q',
        '00ZP007B00R',
        '00ZP007B00S',
        '00ZP007B00T',
        '00ZP007B00U'
      ],
      title: '',
      h: '500px',
      total: 0,
      formData: {
        instockNo: '',
        instockPlateNumber: '',
        productType: '',
        steelMillName: '',
        specification: '',
        model: '',
        primaryCustomerTaxId: '',
        secondaryCustomerTaxId: '',
        instockDateStart: '',
        instockDateEnd: ''
      },
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      customerData: [], // 货主数据
      productTypeData: [], // 货物类型
      steelMillNameData: [], // 产地
      specificationData: [], // 规格
      modelData: [], // 材质
      lengthData: [],
      specificationDisabled: true,
      steelMillNameDisabled: true,
      modelDisabled: true,
      goodsName: '',
      placeOfOrigin: '',
      specificationVal: '',
      modelVal: '',
      tableList: [],
      HZData: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/recordQuery')
    this.getRelationCustomerS()
    this.JfgetDeleteInStockExpLists()
    this.getVirtualBalingList()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 205 + 'px'
  },
  methods: {
    // 列表查询
    JfgetDeleteInStockExpLists () {
      JfgetDeleteInStockExpList(
        {
          pageNo: this.pageInfo.pageNo,
          pageSize: this.pageInfo.pageSize,
          instockNo: this.formData.instockNo,
          instockPlateNumber: this.formData.instockPlateNumber,
          primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
          secondaryCustomerTaxId: this.formData.secondaryCustomerTaxId,
          productType: this.formData.productType,
          steelMillName: this.formData.steelMillName,
          specification: this.formData.specification,
          model: this.formData.model,
          instockDateStart: this.formData.instockDateStart,
          instockDateEnd: this.formData.instockDateEnd
        }
      )
        .then(res => {
          console.log(res)
          this.tableList = res.list
          this.total = res.total
          this.tableList.forEach(item => {
            item.allWeight = parseFloat(Number(item.allWeight).toFixed(6))
            item.weight = parseFloat(Number(item.weight).toFixed(6))
          })
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chaxun () {
      this.JfgetDeleteInStockExpLists()
    },
    chongzhi () {
      this.formData.primaryCustomerTaxId = ''
      this.formData.instockNo = ''
      this.formData.instockPlateNumber = ''
      this.formData.productType = ''
      this.formData.steelMillName = ''
      this.formData.specification = ''
      this.formData.model = ''
      this.formData.secondaryCustomerTaxId = ''
      this.formData.instockDateStart = ''
      this.formData.instockDateEnd = ''
      this.JfgetDeleteInStockExpLists()
      this.getVirtualBalingList()
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          // this.productTypeData = Array.from(new Set(res.map(item => item.productTypeName)))
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      // this.goodsName = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      // this.placeOfOrigin = val

      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      // this.specificationVal = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      // this.modelVal = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },

    // 每页条数
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.JfgetDeleteInStockExpLists()
    },
    // 当前页
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.JfgetDeleteInStockExpLists()
    },
    // 导出
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/stockExpInfo/exportDeleteInStockExpList',
        { ...this.formData, instockStatus: '1' },
        '删除记录信息表'
      )
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          // console.log(res)
          this.HZData = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    }
  }
}
</script>
<style scoped lang='less'>
.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
.formBox /deep/ .el-form-item{
  margin-bottom:6px!important;
}

</style>
